export const userAdditionalRoles = [
    { key: "onboarding", label: "Onboarding" },
    { key: "technology_owner", label: "Technology Owner" },
    { key: "delivery_owner", label: "Delivery Owner" },
    { key: "client_owner", label: "Client Owner" },
] as const;
